import { TrendingDown, TrendingUp, Shuffle } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { TONE } from "./utils";

const INFO = {
  UP: { icon: TrendingUp, text: "Bitcoin went up over the last 1, 5 AND 15 minutes. Every timeframe agrees: buyers are in control right now." },
  DOWN: { icon: TrendingDown, text: "Bitcoin went down over the last 1, 5 AND 15 minutes. Every timeframe agrees: sellers are in control right now." },
  MIXED: { icon: Shuffle, text: "The timeframes disagree — e.g. up over 15 minutes but down in the last minute. There's no clear direction, so be extra careful." },
};

export const MomentumCard = ({ btc }) => {
  if (!btc) return <section className="card p-5 h-full"><Skeleton className="h-40 bg-[#111A2C]" /></section>;
  const m = btc.momentum, I = INFO[m];
  const votes = [btc.change_1m, btc.change_5m, btc.change_15m];
  const score = votes.reduce((s, v) => s + Math.sign(v), 0);
  return (
    <section className="card p-5 sm:p-6 fade-up h-full flex flex-col" data-testid="momentum-card">
      <div className="text-xs uppercase tracking-widest font-num text-slate-400">Momentum</div>
      <div className={`inline-flex items-center gap-2 self-start mt-3 px-4 py-2 rounded-full border font-head font-extrabold text-2xl ${TONE[m]}`} data-testid="momentum-label">
        <I.icon className="w-6 h-6" /> {m}
      </div>
      <p className="text-sm text-slate-300 leading-relaxed mt-4" data-testid="momentum-explanation">{I.text}</p>
      <div className="mt-5">
        <div className="flex justify-between text-[10px] font-num uppercase tracking-widest text-slate-500">
          <span>Down</span><span>Mixed</span><span>Up</span>
        </div>
        <div className="relative h-2 rounded-full bg-gradient-to-r from-red-500/40 via-amber-400/40 to-emerald-500/40 mt-1">
          <div className="absolute -top-1 w-4 h-4 rounded-full bg-white border-2 border-[#05070D] transition-[left] duration-700"
            style={{ left: `calc(${((score + 3) / 6) * 100}% - 8px)` }} data-testid="momentum-meter" />
        </div>
        <p className="text-[11px] text-slate-500 mt-2">
          {votes.filter((v) => v > 0).length} of 3 timeframes are up. Momentum describes the recent past — it doesn't predict the future.
        </p>
      </div>
    </section>
  );
};
